
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { Grid } from '@material-ui/core';
import clsx from 'clsx';

import BlogDetail from 'src/components-pages/blog/blogDetail';
import BlogProvider from 'src/components-pages/blog/BlogProvider';

import { BlogList } from 'src/components-pages/blog/blogList';
import BlogSeo from 'src/components-pages/blog/seo';

import useBlogStyles from 'src/components-pages/blog/styles';

import BaseLayout, { BaseModelProps } from 'src/components/layouts/BaseLayout';
import BlogFooterTitle from 'src/components-pages/blog/blogFooterTitle';
import { getBaseModels } from 'src/graphql/models/query';
import { GetStaticProps } from 'next';

interface Props extends BaseModelProps {}

const BlogPage = ({ baseData }: Props) => {
    const classes = useBlogStyles();

    return (
        <BlogProvider>
            <BaseLayout
                baseData={baseData}
                variant="black"
                classes={{
                    root: classes.root
                }}>
                <BlogSeo />

                <BlogFooterTitle>
                    <BlogDetail />

                    <Grid container className={clsx(classes.row)}>
                        <BlogList />
                    </Grid>
                </BlogFooterTitle>
            </BaseLayout>
        </BlogProvider>
    );
};

 const _getStaticProps: GetStaticProps = async () => {
    const baseData = await getBaseModels();
    return {
        props: { baseData },
        revalidate: 100
    };
};

export default BlogPage;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/blog/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  